import { render, staticRenderFns } from "./SliderElement.vue?vue&type=template&id=172673b8"
import script from "./SliderElement.vue?vue&type=script&lang=ts"
export * from "./SliderElement.vue?vue&type=script&lang=ts"
import style0 from "./SliderElement.vue?vue&type=style&index=0&id=172673b8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports